// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__htQrc","footerLink":"Footer_footerLink__9IDCO"};